import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import WhiteButton from "./WhiteButton";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const workList = [
  {
    id: 4,
    title: "Predictive meets generative",
    description: "Revolutionize Quote to Cash for Operational Excellence",
    imageURL: "/images/case-studies/4/case-image-0.jpeg",
  },
  {
    id: 7,
    title: "AI-Driven Health Tech Hub",
    description: "From Smarter Patient Care to Scalable Digital Solutions",
    imageURL: "/images/case-studies/7/case-image-0.jpeg",
  },
  {
    id: 8,
    title: "Intelligent Revenue Optimization",
    description: "Optimizes billing, prevents losses & improves forecasting",
    imageURL: "/images/case-studies/8/case-image-3.jpeg",
  },
  {
    id: 5,
    title: "Campaigns Never Die",
    description: "Dynamic Content Creation for Dungeon Masters",
    imageURL: "/images/case-studies/5/case-image-0.jpeg",
  },
];

const WorkedOnSection = ({
  title = "We worked on this as well",
  className = "",
  showExploreMore = false,
}) => {
  const navigate = useNavigate();

  const handleClick = (id) => {
    navigate(`/case-study/${id}`);
  };

  const scrollContainerRef = useRef(null);

  const scrollLeft = () => {
    scrollContainerRef.current.scrollLeft -= 300;
  };

  const scrollRight = () => {
    scrollContainerRef.current.scrollLeft += 300;
  };

  return (
    <div className={`relative pb-48 mt-32 md:mt-0 ${className}`}>
      <div className="flex flex-row items-center justify-between px-4 md:px-20">
        <h2 className="font-bold text-[28px] md:text-[40px] leading-[140%] tracking-[0%]">
          {title}
        </h2>
        {/* Navigation Arrows */}
        <div className="hidden md:flex space-x-4 pr-10">
          <button
            onClick={scrollLeft}
            aria-label="Previous testimonial"
            className="flex w-14 h-14 items-center justify-center rounded-full bg-black shadow-[0_0_15px_rgba(255,255,255,0.3)] hover:shadow-[0_0_25px_rgba(255,255,255,0.5)] transition-all z-10"
          >
            <ChevronLeft size={24} className="text-white" />
          </button>
          <button
            onClick={scrollRight}
            aria-label="Next testimonial"
            className="flex w-14 h-14 items-center justify-center rounded-full bg-black shadow-[0_0_15px_rgba(255,255,255,0.3)] hover:shadow-[0_0_25px_rgba(255,255,255,0.5)] transition-all z-10"
          >
            <ChevronRight size={24} className="text-white" />
          </button>
        </div>
      </div>

      <div className="relative overflow-hidden mt-6 md:mt-12">
        <div
          ref={scrollContainerRef}
          className="overflow-x-auto scroll-smooth scrollbar-hidden no-scrollbar"
          style={{
            scrollbarWidth: "none",
            "-ms-overflow-style": "none",
          }}
        >
          <div className="inline-flex space-x-4 px-4 md:px-20 py-4">
            {workList.map((card, index) => (
              <div
                key={`${card.title}-${index}`}
                onClick={card.id ? () => handleClick(card.id) : undefined}
                className={`inline-block group rounded-2xl overflow-hidden min-w-[50%] md:min-w-[28%] h-[466px] md:h-[588px] relative shadow-lg border-2 border-app-background hover:border-zinc-500 transition-all ease-linear duration-300 ${
                  card.id ? "cursor-pointer" : ""
                }`}
              >
                <div className="flex flex-col w-full h-full">
                  <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10">
                    <img
                      src={card.imageURL}
                      alt="AI Strategy"
                      className="w-full h-full object-cover absolute top-0 left-0 transition-all ease-linear duration-300 group-hover:scale-[101%] object-center grayscale"
                    />
                  </div>
                  {/* Spacer to push content to bottom */}
                  <div className="flex-grow"></div>
                  {card.tag && (
                    <div className="left-0 top-0 flex absolute z-10 m-4 md:m-4">
                      <div
                        className={`group relative p-[1px] bg-work-tag-border rounded-full transition-all duration-300`}
                      >
                        <div
                          className={`"relative flex items-center gap-2 text-white leading-[140%] font-bold font-theBrittanySans bg-[#555555] rounded-full shadow-[0px_0px_5.6px_1px_#A8A8A8] transition duration-300" px-2 py-1.5 md:px-3 md:py-1 cursor-default`}
                        >
                          <span className="text-xs md:text-xs">{card.tag}</span>
                          <div className="absolute inset-0 rounded-full border-[1px] border-gray-400/50 blur-md" />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="h-20 bg-gradient-to-b from-transparent from-10%  to-[#252525] to-100% z-10 "></div>
                  <div className="flex flex-col items-start px-4 md:px-3 pt-4 md:pt-8 pb-10 md:pb-14 bg-[#252525] rounded-b-xl relative z-10">
                    <h2 className="text-sm font-bold font-theBrittanySans line-clamp-1">
                      {card.title}
                    </h2>
                    <p className="text-xl font-medium mt-2 text-wrap line-clamp-2">
                      {card.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {showExploreMore && (
          <div className="flex items-center justify-center mt-12 mb-5">
            <WhiteButton
              text="See more"
              icon={<ArrowRight />}
              onClick={() => navigate("/case-studies")}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkedOnSection;
